import React from "react";
import "./styles.css";

export default function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-serif font-bold mb-4">
          Jolie Main Studio
        </h1>
        <p className="text-lg text-gray-600">
          Project initialized. Ready for full code.
        </p>
        <p className="text-sm text-gray-500 mt-2">
          Replace this App.tsx with your complete code from Google Doc
        </p>
      </div>
    </div>
  );
}
